import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path
                d="M32 0v32H0V0h32zM10.707 12.775h-3.99V25.6h3.99V12.775zm10.147-.318c-1.94 0-3.24 1.063-3.772 2.072h-.054v-1.754h-3.82V25.6h3.98v-6.343c0-1.673.316-3.294 2.39-3.294 2.046 0 2.072 1.913 2.072 3.4V25.6h3.985v-7.034c0-3.454-.746-6.109-4.781-6.109zM8.713 6.4a2.31 2.31 0 1 0 0 4.623 2.312 2.312 0 0 0 0-4.623z"
                fill="#2E5996"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
